import React from 'react';
import './listitems.scss';
import strings from "../../../components/Language/index.js";
import axios from 'axios';
import { api } from '../../../components/config/api.js';
import { getToken, storeUserData } from '../../../components/Util/index.js';
import _ from 'lodash';
import { io } from "socket.io-client";
import LoaderContext from '../../../components/Loader/LoaderContext.js';
import BotCard from '../../../components/BotCard';

class BOLLBot extends React.Component {

    static contextType = LoaderContext;
    constructor(props) {
        super(props);
        this.state = {
            access_token: "",
            botLiveData: [],
            data: [],
            pariNames: "",
            get_live_bot: false,
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            setTimeout(() => {
                this.setState({ access_token: token });
                this.getData();
            });

            try {
                var self = this;
                var socket = io.connect('https://price.ctsbot.com');
                socket.on('connect', function (data) {
                });
                socket.on('price', function (data) {
                    self.setState({ botLiveData: data, get_live_bot: true, })
                });
            }
            catch (e) { }
        }
    }

    getData() {
        const { setLoading } = this.context;
        var self = this;
        if (self.state.access_token) {
            setLoading(true);
            axios({
                method: 'GET',
                url: api.botb_report,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage()
                }
            }).then(function (ress) {
                if (ress.data && ress.data.error === 200) {

                    var parinames = "";
                    var parinamesArray = [];
                    var botData = _.filter(ress.data.data, function (o, key) {
                        o.average_ = (o.total_usdt_cost > 0) ? (o.total_usdt_qty / o.total_usdt_cost) : 0;
                        o.is_calculate = (o.total_usdt_cost > 0) ? true : false;

                        if (o.pair.name && parinamesArray.indexOf(o.pair.name) == -1) {
                            if (parinames) {
                                parinames += `,`;
                            }
                            parinames += `"` + o.pair.name + `"`;
                            parinamesArray.push(o.pair.name);
                        }

                        return o;
                    });
                    self.setState({ data: botData, pariNames: parinames });

                    if (parinames && parinames.length != 0) {
                        self.getLiveData();
                        setInterval(() => {
                            self.getLiveData();
                        }, 5000);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                }
            }).catch(function (e) {
                //toast.error(e.message);
                setLoading(false);
            });
        }
    };

    getLiveData() {
        const { setLoading } = this.context;
        var self = this;
        if (self.state.access_token) {
            var API = api.marketData;
            axios({
                method: 'GET',
                url: API,
                headers: {
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                if (ress && ress.status == 200) {
                    _.filter(self.state.data, function (o) {
                        var finalLiveData = _.find(ress.data, { symbol: o.pair.name });
                        if (finalLiveData) {
                            o.liveData = finalLiveData;
                            o.lastPrice = finalLiveData.lastPrice;
                        }
                        return o;
                    })
                    self.setState({ get_live_bot: true });
                }
                self.setState({ is_load: false });
                setTimeout(() => {
                    setLoading(false);
                });
            }).catch(function (e) {
                setLoading(false);
            });
        }
    };

    render() {
        return (
            <>
                {
                    this.state.data.map((item, i) => {
                        const symbolName = (item.pair && item.pair.name) ? item.pair.name : "";
                        const socketPrice = (this.state.botLiveData && this.state.botLiveData[symbolName] != null) ? parseFloat(this.state.botLiveData[symbolName]) : null;
                        const livePrice = (socketPrice != null && !isNaN(socketPrice)) ? socketPrice : ((item.liveData && item.liveData.lastPrice) ? parseFloat(item.liveData.lastPrice) : item.lastPrice);
                        return <BotCard key={i + 1001} to={{ pathname: `/cts-bot/${item._id}` }} item={item} livePrice={livePrice} ready={this.state.get_live_bot} />;
                    })
                }
            </>
        );
    }
}

export default BOLLBot;
